import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid2";
import Radio from "@mui/material/Radio";

interface IProps {
    type: string;
    setType: (type: string) => void;
}

const checkBoxOptions = ["Total", "Arrivals", "Departures"];

export default function Directions({ setType, type }: IProps) {
 
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setType(event.target.value);
    };

    return (
        <Grid container sx={{ m: 0, p: 0 }}>
            {checkBoxOptions.map((option) => (
                <Grid size={4} key={option}>
                    <FormControlLabel
                        control={
                            <Radio
                                value={option}
                                checked={type === option}
                                onChange={handleChange}
                            />
                        }
                        label={option}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
